module.exports = __webpack_public_path__ + "static/media/25.fa5e109d.jpg";